import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Popup, Loader } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import SearchField from '../../components/elements/SearchField'
import ListSelector from '../../components/elements/ListSelector'
import Properties from '../../components/elements/Properties'
import Details from '../../components/elements/Details'
import Confirm from '../../components/elements/Confirm'
import Sticker from '../../components/elements/Sticker'
import LocationStickers from '../../components/elements/LocationStickers'
import UpdateLocationPopup from '../popups/locations/UpdateLocationPopup'
import HistoryItemPopup from '../popups/items/HistoryItemPopup'
import CreateInventoryPopup from '../popups/inventories/CreateInventoryPopup'
import Grant from '../elements/Grant'

import ListAction from '../../actions/locations/ListTreeAction'
import GetAction from '../../actions/locations/GetFullAction'
import ChangePageAction from '../../actions/app/ChangePageAction'
import PrintInventoryAction from '../../actions/print/PrintInventoryAction'

class LocationsViewPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    this.state={
      // Search text of the right search field
      search: '',
      // Is editing location infos
      locationUpdate: false,
      // ID of item currently open in history popup
      itemHistoryId: null,
      // Is executing an inventory
      isExecute: false,
      // Is printing the inventory
      isPrintingInventory: false
    }

    // Bind events
    this.onSelect = this.onSelect.bind(this)
    this.onClickManage = this.onClickManage.bind(this)
    this.onChangeSearch = this.onChangeSearch.bind(this)
    this.onClickLocationUpdate = this.onClickLocationUpdate.bind(this)
    this.onCloseLocationUpdate = this.onCloseLocationUpdate.bind(this)
    this.onClickItemHistory = this.onClickItemHistory.bind(this)
    this.onCloseItemHistory = this.onCloseItemHistory.bind(this)
    this.onClickGoToProduct = this.onClickGoToProduct.bind(this)
    this.onClickGoToInventory = this.onClickGoToInventory.bind(this)
    this.onClickRunInventory = this.onClickRunInventory.bind(this)
    this.onCloseRunInventory = this.onCloseRunInventory.bind(this)
    this.onClickPrintInventory = this.onClickPrintInventory.bind(this)
    this.onConfirmPrintInventory = this.onConfirmPrintInventory.bind(this)
  }

  fetchList() {
    this.props.fetchList()
  }

  fetchOne() {
    this.props.fetchOne(this.props.selected)
  }

  componentDidMount() {
    this.fetchList()
    if (!_.isNull(this.props.selected)) {
      this.fetchOne()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // After selecting a location, load details
    if (
      prevProps.selected !== this.props.selected
      &&
      !_.isNull(this.props.selected)
    ) {
      this.fetchOne()
    }

    // After printing inventory, refresh
    if (
      prevProps.printIsFetching
      &&
      !this.props.printIsFetching
    ) {
      this.setState({
        isPrintingInventory: false
      })
      AppUtils.setStatus(
        this.props.printError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.printError
          ? AppUtils.errorToText(this.props.printError)
          : 'Inventaire imprimé.'
      )
      if (!this.props.printError) {
        this.fetchOne()
      }
    }
  }

  onSelect(selected) {
    this.props.changePage(AppConstants.PAGE.LOCATIONS_VIEW, selected)
  }

  onClickManage() {
    this.props.changePage(AppConstants.PAGE.LOCATIONS_MANAGE)
  }

  onChangeSearch(search) {
    this.setState({ search })
  }

  onClickLocationUpdate() {
    this.setState({
      locationUpdate: true
    })
  }

  onCloseLocationUpdate(isDirty) {
    this.setState({
      locationUpdate: false
    })
    if (isDirty) {
      this.fetchOne()
      this.fetchList()
    }
  }

  onClickItemHistory(itemHistoryId) {
    return () => {
      this.setState({ itemHistoryId })
    }
  }

  onCloseItemHistory() {
    this.setState({
      itemHistoryId: null
    })
  }

  onClickGoToProduct(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.PRODUCTS_VIEW, id)
    }
  }

  onClickGoToInventory(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.INVENTORY, id)
    }
  }

  onClickRunInventory() {
    this.setState({
      isExecute: true
    })
  }

  onCloseRunInventory(inventoryId) {
    this.setState({
      isExecute: false
    })
    if (inventoryId) {
      this.props.changePage(AppConstants.PAGE.INVENTORY, inventoryId)
    }
  }

  onClickPrintInventory() {
    this.setState({
      isPrintingInventory: true
    })
  }

  onConfirmPrintInventory(proceed) {
    if (proceed) {
      this.props.printInventory(this.props.selected)
    }
    else {
      this.setState({
        isPrintingInventory: false
      })
    }
  }

  render() {
    const filter = (locations) => (
      _.filter(
        _.map(
          locations,
          (location) => (_.extend(
            {},
            location,
            _.size(location.children) > 0
              ? {
                  children: filter(location.children)
                }
              : {}

          ))
        ),
        (location) => (
          _.size(location.children) > 0
          ||
          AppUtils.search(location.name, this.state.search)
        )
      )
    )
    const filteredList = _.isArray(this.props.listData)
      ? filter(this.props.listData)
      : null
    const linearList = []
    if (this.props.listIsFetching) {
      linearList.push(
        <ListSelector.Header
          foreground='000000'
          background='ffffff'
          text='Chargement...'
        />
      )
    }
    else {
      if (_.isArray(filteredList) && _.size(filteredList) > 0) {
        const addToLinearList = (locations, level=0) => {
          _.each(locations, (location) => {
            linearList.push(
              <ListSelector.Item
                value={location.id}
                text={
                  <Sticker
                    foreground={location.color.foreground}
                    background={location.color.background}
                    text={location.name}
                  />
                }
                level={level}
              />
            )
            addToLinearList(location.children, level+1)
          })
        }
        addToLinearList(filteredList)
      }
      else {
        linearList.push(
          <ListSelector.Header
            foreground='000000'
            background='ffffff'
            text='Rien à afficher.'
          />
        )
      }
    }
    const productsList = this.props.getData
      ? (
          _.flatten(
            _.map(
              this.props.getData.categories,
              (category) => (
                _.union(
                  [
                    Table.headerRow(
                      category.category.name,
                      category.category.color.foreground,
                      category.category.color.background
                    )
                  ],
                  _.map(
                    category.products,
                    (product) => {
                      const compartments = (
                        _.map(
                          _.values(
                            _.groupBy(
                              _.map(
                                product.items,
                                (item) => ({
                                  compartment: item.compartment,
                                  quantity: _.isNull(item.deleted) ? 1 : 0
                                })
                              ),
                              (item) => (item.compartment)
                            )
                          ),
                          (group) => _.reduce(
                            group,
                            (acc, compartment) => ({
                              compartment: compartment.compartment,
                              quantity: acc.quantity + compartment.quantity
                            }),
                            {
                              compartment: null,
                              quantity: 0
                            }
                          )
                        )
                      )
                      const worstIcon = AppUtils.worstIcon(_.union(
                        [ Details.ICON.INFO ],
                        _.map(
                          _.filter(
                            product.items,
                            (item) => (_.isNull(item.deleted))
                          ),
                          (item) => (AppUtils.getDetailsInventory(item).icon)
                        ),
                        _.flatten(
                          _.map(
                            _.filter(
                              product.items,
                              (item) => (_.isNull(item.deleted))
                            ),
                            (item) => (
                              _.map(
                                item.maintenances,
                                (maintenance) => (AppUtils.dateToReminder(maintenance.next).icon)
                              )
                            )
                          )
                        )
                      ))
                      return (
                        _.extend(
                          {},
                          product,
                          {
                            compartments : _.size(compartments) === 1
                              ? compartments[0].compartment
                              : compartments,
                            quantity: _.size(product.items),
                            icon: worstIcon
                          }
                        )
                      )
                    }
                  )
                )
              )
            )
          )
        )
      : null
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 20%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                flex: '0 0 38px',
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <div style={{ flex: '0 0 auto' }}>
                <Popup
                  trigger={
                    <Button
                      icon='edit'
                      onClick={this.onClickManage}
                      style={{ margin: 0 }}
                    />
                  }
                  inverted={true}
                  on='hover'
                  position='right center'
                >
                  Gestion des emplacements
                </Popup>
              </div>
              <div style={{
                flex: '1 0 auto',
                marginLeft: '8px'
              }}>
                <SearchField
                  value={this.state.search}
                  onChange={this.onChangeSearch}
                />
              </div>
            </div>
            <ListSelector
              style={{
                flex: '1 1 auto',
                marginTop: '8px'
              }}
              selected={this.props.selected}
              onSelect={this.onSelect}
              children={linearList}
            />
          </Page.Element>
          <Page.Container
            flex='4 4 80%'
            direction={Page.DIRECTION.COL}
          >
            {
              !_.isNull(this.props.selected)
                ? (
                    this.props.getIsFetching || !this.props.getData
                      ? <Page.Element
                          flex='1 1 100%'
                        >
                          <Loader
                            active={true}
                            content='Chargement...'
                            size='huge'
                          />
                        </Page.Element>
                      : <React.Fragment>
                          <Page.Element
                            flex='0 0 auto'
                            withBorders={true}
                          >
                            <Header
                              title="Description de l'emplacement"
                              right={
                                <Grant role={Grant.ROLE.MANAGE}>
                                  <Button
                                    compact={true}
                                    icon='pencil'
                                    color='orange'
                                    onClick={this.onClickLocationUpdate}
                                  />
                                </Grant>
                              }
                              alignTop={true}
                            />
                            <Properties
                              content={[
                                {
                                  key: 'Nom',
                                  value: this.props.getData.name
                                },
                                {
                                  key: 'Etiquettage',
                                  value: (
                                    <React.Fragment>
                                      <LocationStickers
                                        stickers={this.props.getData.stickers}
                                      />
                                      {
                                        !this.props.getData.islabeled
                                          ? <Details
                                              icon={Details.ICON.INFO}
                                              action={Details.ACTION.HOVER}
                                              content="Cet emplacement spécifique n'est pas étiquetté sur le matériel correspondant"
                                            />
                                          : null
                                      }
                                    </React.Fragment>
                                  )
                                },
                                {
                                  key: 'Remarque',
                                  value: this.props.getData.remark || '-'
                                }
                              ]}
                            />
                          </Page.Element>
                          <Page.Element
                            flex='3 3 auto'
                            withBorders={true}
                            style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Header
                              style={{
                                flex: '0 0 auto'
                              }}
                              title='Matériel'
                            />
                            <Table
                              columns={[
                                // Emplacement
                                ColumnsProvider.locationStickersWithLabelStatus(this),
                                // Matériel
                                ColumnsProvider.itemProduct,
                                // Compartiment
                                ColumnsProvider.itemCompartmentMultiple(null),
                                // Quantité
                                ColumnsProvider.itemQuantityWithDetails(null, (row) => (_.union(
                                  // N° (only if prefixed)
                                  !_.isNull(row.product.prefix)
                                    ? [ ColumnsProvider.itemNumber ]
                                    : [],
                                  [
                                    // Compartiment
                                    ColumnsProvider.itemCompartmentBasic,
                                    // Inventaire
                                    ColumnsProvider.itemInventory,
                                    // Maintenance
                                    ColumnsProvider.itemMaintenance,
                                    // Remarque
                                    ColumnsProvider.itemRemark,
                                    // Ajouté
                                    ColumnsProvider.itemCreated,
                                    // Action
                                    ColumnsProvider.itemActions(
                                      false,
                                      this.onClickItemHistory
                                    )
                                  ]
                                ))),
                                // Action
                                ColumnsProvider.actionGoTo(this.onClickGoToProduct, 'product.id')
                              ]}
                              data={productsList}
                              error={null}
                              isLoading={false}
                              emptyMessage="Cet emplacement ne contient pas de matériel."
                            />
                          </Page.Element>
                          <Page.Element
                            flex='1 1 auto'
                            withBorders={true}
                          >
                            <Header
                              style={{
                                flex: '0 0 auto'
                              }}
                              title='Inventaire'
                              right={
                                <Grant role={Grant.ROLE.INVENTORY}>
                                  <Button
                                    compact={true}
                                    icon='play'
                                    content='Effectuer maintenant'
                                    onClick={this.onClickRunInventory}
                                  />
                                </Grant>
                              }
                            />
                            <Table
                              columns={[
                                // Date
                                ColumnsProvider.genericDate,
                                // Titre
                                ColumnsProvider.inventoryTitle,
                                // Fait par
                                ColumnsProvider.inventoryUserAndPeople,
                                // Résultat
                                ColumnsProvider.inventoryResult,
                                // Remarque
                                ColumnsProvider.inventoryRemark,
                                // Actions
                                ColumnsProvider.actionGoTo(this.onClickGoToInventory)
                              ]}
                              data={this.props.getData.inventories}
                              error={null}
                              isLoading={false}
                              emptyMessage="Aucun inventaire de cet emplacement n'a été effectué pour le moment."
                            />
                          </Page.Element>
                          <Page.Element
                            flex='0 0 auto'
                            withBorders={true}
                          >
                            <Header
                              style={{
                                flex: '0 0 auto'
                              }}
                              title="Impression de l'inventaire"
                              right={
                                <Button
                                  compact={true}
                                  icon='print'
                                  content='Imprimer maintenant'
                                  onClick={this.onClickPrintInventory}
                                />
                              }
                              alignTop={true}
                            />
                            <p>
                              {AppUtils.displayDate(this.props.getData.printedinventory, "Jamais imprimé")}
                            </p>
                          </Page.Element>
                        </React.Fragment>
                  )
                : null
            }
          </Page.Container>
        </Page>
        {
          this.state.locationUpdate && !_.isNull(this.props.selected)
            ? <UpdateLocationPopup
                id={this.props.selected}
                onClose={this.onCloseLocationUpdate}
              />
            : null
        }
        {
          !_.isNull(this.state.itemHistoryId) && !_.isNull(this.props.selected)
            ? <HistoryItemPopup
                id={this.state.itemHistoryId}
                onClose={this.onCloseItemHistory}
              />
            : null
        }
        {
          this.state.isExecute && !_.isNull(this.props.selected)
            ? <CreateInventoryPopup
                location={this.props.selected}
                onClose={this.onCloseRunInventory}
              />
            : null
        }
        {
          this.state.isPrintingInventory
            ? <Confirm
                header="Impression de l'inventaire"
                body="Vous êtes sur le point d'imprimer l'inventaire pour cet emplacement. Celui-ci sera téléchargé au format PDF. Voulez-vous continuer ?"
                confirmText="Imprimer"
                confirmColor='blue'
                confirmIcon='print'
                isProceeding={this.props.printIsFetching}
                callback={this.onConfirmPrintInventory}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

LocationsViewPage.propTypes = {
  // Properties

  // Redux State
  selected: PropTypes.number,
  listData: PropTypes.array,
  listIsFetching: PropTypes.bool.isRequired,
  listError: PropTypes.object,
  getData: PropTypes.object,
  getIsFetching: PropTypes.bool.isRequired,
  getError: PropTypes.object,
  printIsFetching: PropTypes.bool.isRequired,
  printError: PropTypes.object,

  // Redux Actions
  fetchList: PropTypes.func.isRequired,
  fetchOne: PropTypes.func.isRequired,
  printInventory: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    selected: state.entities.locations.view,
    listData: state.entities.locations.list.tree.data,
    listIsFetching: state.entities.locations.list.tree.isFetching,
    listError: state.entities.locations.list.tree.error,
    getData: state.entities.locations.get.full.data,
    getIsFetching: state.entities.locations.get.full.isFetching,
    getError: state.entities.locations.get.full.error,
    printIsFetching: state.print.inventory.isFetching,
    printError: state.print.inventory.error
  }),
  (dispatch) => ({
    fetchList: () => (dispatch(ListAction({}))),
    fetchOne: (id) => (dispatch(GetAction({ id }))),
    printInventory: (id) => (dispatch(PrintInventoryAction({ id }))),
    changePage: (page, id=undefined) => (dispatch(ChangePageAction(page, { id })))
  })
)(LocationsViewPage)



// WEBPACK FOOTER //
// ./src/containers/pages/LocationsViewPage.js